import AddEditFormCst from "@components/AddEditFormCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { useFetchMock } from "src/mock_data/useMockData";
import { Box, Container } from "@mui/material";
import { PagesID } from "@utils/utilsConfigurations";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchDetailWrapper } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { MethodType } from "src/services/type";
import { fetcher } from "src/services/config";
import useSWRMutation from "swr/mutation";

const EditTerm: React.FC<{ page: PagesID }> = ({ page }) => {
  const { t } = useTranslation(["forums-terms-page"]);
  const navigate = useNavigate();
  const { id, termId } = useParams();

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  const { columns, dataDetail } = useFetchDetailWrapper(
    `${ServicesURL.postWrapper}?term_id=${termId}`,
    {
      body: {},
      method: `${MethodType.GET}`,
      endpoint: `${ServicesURL.getTerms}?term_id=${termId}`,
      initiativeid: null,
      corporateid: +id!,
    },
    PagesID["corporate.initiative.discussion.terms.edit"],
    true
  );

  const { trigger: triggerEditTerms } = useSWRMutation(
    ServicesURL.postWrapper,
    (url: string, arg: { arg: any }) =>
      fetcher<any>(`${url}`, MethodType.POST, { ...arg.arg })
  );

  const onSubmit = async (inputForm: any) => {
    let wrapperObj = {
      body: {
        name: inputForm?.name,
      },
      method: `${MethodType.PUT}`,
      endpoint: `${ServicesURL.getTerms}?term_id=${termId}`,
      initiativeid: null,
      corporateid: +id!,
    };
    try {
      await triggerEditTerms(wrapperObj);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      setOpenToast(undefined);
    }
  };

  return (
    <>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-terms.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <AddEditFormCst
            row={dataDetail || []}
            actionsForForms={[]}
            columns={columns}
            onSubmit={onSubmit}
            backButton={() => {
              navigate(-1);
            }}
          />
        </Box>
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-edit")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </>
  );
};

export default EditTerm;
